import { __awaiter } from 'tslib';
import { MessageSource, InitResult, IMEvent, FlightStatus } from '../../consts.js';
import { BaseProcessor } from './BaseProcessor.js';
import { ServiceIdentity } from '../RuntimeContext.js';

class TextMessageProcessor extends BaseProcessor {
    process(item) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            // 不处理特殊消息
            if (!item.data.isNormalMsg) {
                return item;
            }
            const raw = this.resolve(ServiceIdentity.MessageManager).getRaw((_a = item.conv) === null || _a === void 0 ? void 0 : _a.id, item.data.clientId);
            const msgOnline = item.data.source !== undefined &&
                (item.data.source === MessageSource.Online ||
                    item.data.source === MessageSource.UserInbox);
            const msgIsSelfSend = (raw === null || raw === void 0 ? void 0 : raw.flightStatus) !== undefined && msgOnline;
            // 先刷一次, 把消息更新给刷进去
            this.resolve(ServiceIdentity.MessageManager).upsert(item.data);
            const updatedMsg = this.resolve(ServiceIdentity.MessageManager).getRaw(item.data.conversationId, item.data.clientId);
            if (!raw) { // 消息之前不存在, 需要发一个 event, 代表是新收到的消息
                // 只有来自拉混链或者长链push的消息才会触发这个事件
                // 陌生人消息长链不会进这个地方, 短链不应该触发
                if (msgOnline && !item.data.isStrangerMessage) {
                    if (item.data.sender !== this.ctx.option.userId) { // 判断消息是不是自己的, 控制触发不同类型的事件
                        if (this.ctx.initResult === InitResult.Succeeded) {
                            this.resolve(ServiceIdentity.EventBus).emit(IMEvent.ReceiveNewMessage, this, updatedMsg);
                        }
                    }
                    else { // 消息不存在但是是自己发的, 说明是多端同步或者服务端下发的消息
                        if (this.ctx.initResult === InitResult.Succeeded) {
                            this.resolve(ServiceIdentity.EventBus).emit(IMEvent.ReceiveSelfMessage, this, updatedMsg);
                        }
                    }
                }
            }
            else { // 消息已经存在, 判断下是不是自己发的
                if (msgIsSelfSend && updatedMsg.flightStatus !== FlightStatus.Received) {
                    // 需要修改 flightStatus
                    updatedMsg.flightStatus = FlightStatus.Received;
                    if (this.ctx.initResult === InitResult.Succeeded) {
                        this.resolve(ServiceIdentity.EventBus).emit(IMEvent.ReceiveSelfMessage, this, updatedMsg);
                    }
                    this.resolve(ServiceIdentity.MessageManager).upsert(updatedMsg);
                }
                // 理论上不应该出现这个else 消息已经存在本地但不是自己发的
                // 不做任何操作
            }
            return item;
        });
    }
}

export { TextMessageProcessor };
//# sourceMappingURL=TextMessageProcessor.js.map
